export type ThemeMode = 'light' | 'dark';

export type ThemeState = {
    mode: ThemeMode;
};

const initialState: ThemeState = {
    mode: 'dark', // Default to dark mode
};

export const THEME_ACTION_TYPES = {
    SET_THEME_MODE: 'SET_THEME_MODE',
    TOGGLE_THEME: 'TOGGLE_THEME',
};

function themeReducer(state: ThemeState = initialState, action: { type: string, payload?: ThemeMode }) {
    switch (action.type) {
        case THEME_ACTION_TYPES.SET_THEME_MODE:
            return { ...state, mode: action.payload || 'dark' };
        case THEME_ACTION_TYPES.TOGGLE_THEME:
            return { ...state, mode: state.mode === 'dark' ? 'light' : 'dark' };
        default:
            return state;
    }
}

export default themeReducer;

